export const members = [
  {
    id: "1",
    name: "Amanda Ribeiro",
    profession: "Psicóloga & Coach",
    description: "Ama conectar pessoas e acredita que toda mulher carrega uma luz única para compartilhar com o mundo.",
    photo: "/img/readdy/34113fbc611b.jpg",
    whatsapp: "5511999991111",
    email: "amanda@exemplo.com",
    instagram: "@amanda.ribeiro",
  },
  {
    id: "2",
    name: "Carolina Mendes",
    profession: "Empresária & Mentora",
    description: "Construiu dois negócios do zero e hoje dedica sua energia a ajudar outras mulheres a florescerem.",
    photo: "/img/readdy/91a0002a1e34.jpg",
    whatsapp: "5511999992222",
    email: "carolina@exemplo.com",
    instagram: "@carol.mendes",
  },
  {
    id: "3",
    name: "Fernanda Oliveira",
    profession: "Designer & Artista",
    description: "Criativa de coração, enxerga beleza em cada detalhe. Ama encontros que nutrem a alma e inspiram novas ideias.",
    photo: "/img/readdy/43f9141e7c12.jpg",
    whatsapp: "5511999993333",
    email: "fernanda@exemplo.com",
    instagram: "@fernanda.art",
  },
  {
    id: "4",
    name: "Helena Costa",
    profession: "Pastora & Conselheira",
    description: "Há mais de 20 anos caminha ao lado de mulheres, oferecendo apoio espiritual e emocional em todas as estações da vida.",
    photo: "/img/readdy/5d98548c2a79.jpg",
    whatsapp: "5511999994444",
    email: "helena@exemplo.com",
    instagram: "@helena.costa",
  },
  {
    id: "5",
    name: "Juliana Torres",
    profession: "Nutricionista & Yogi",
    description: "Acredita que cuidar do corpo e da mente andam juntos. Ama compartilhar práticas que trazem leveza e equilíbrio.",
    photo: "/img/readdy/edfda564ee80.jpg",
    whatsapp: "5511999995555",
    email: "juliana@exemplo.com",
    instagram: "@ju.torres",
  },
  {
    id: "6",
    name: "Mariana Souza",
    profession: "Terapeuta & Escritora",
    description: "Encontra propósito em transformar dor em palavras que curam. Ama jardins, chá de camomila e conversas até tarde.",
    photo: "/img/readdy/2828a93efa69.jpg",
    whatsapp: "5511999996666",
    email: "mariana@exemplo.com",
    instagram: "@mariana.souza",
  },
  {
    id: "7",
    name: "Priscila Lopes",
    profession: "Fotógrafa & Criadora",
    description: "Captura momentos reais e emoções autênticas. Acredita que cada mulher tem uma história que merece ser contada.",
    photo: "/img/readdy/ae93c300c7e7.jpg",
    whatsapp: "5511999997777",
    email: "priscila@exemplo.com",
    instagram: "@pri.lopes",
  },
  {
    id: "8",
    name: "Tatiana Ferreira",
    profession: "Consultora & Facilitadora",
    description: "Especialista em criar ambientes seguros para que mulheres possam se expressar livremente e crescer juntas.",
    photo: "/img/readdy/3f448b45ff22.jpg",
    whatsapp: "5511999998888",
    email: "tatiana@exemplo.com",
    instagram: "@tati.ferreira",
  },
];